import {
  PersistenceObjectType,
  PersistenceScope,
  SettingsFixedPriorities,
  SettingsManager,
  ViamapPersistenceLayer,
} from "@viamap/viamap2-common";

const JPB_ASSUMPTIONS_SETTING_PREFIX = "jpb.assumptions";

export function isJpbAssumptionUserSettingKey(key: string): boolean {
  return (
    key === JPB_ASSUMPTIONS_SETTING_PREFIX ||
    key.startsWith(`${JPB_ASSUMPTIONS_SETTING_PREFIX}.`)
  );
}

/**
 * Same effect as pressing Reset on every JPB assumption row in User Settings:
 * remove user-level overrides so product defaults from mit-settings.json apply.
 */
export function resetJpbUserAssumptionSettings(): Record<string, unknown> {
  const priority = SettingsFixedPriorities.UserSettings;
  const current = SettingsManager.extractSettingsByPriority(
    priority,
    priority,
    true,
  );
  const remaining: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(current)) {
    if (!isJpbAssumptionUserSettingKey(key)) {
      remaining[key] = value;
    }
  }
  SettingsManager.clearByPriority(priority);
  if (Object.keys(remaining).length > 0) {
    SettingsManager.addSettings(remaining, {
      filename: "LiveSetting",
      priority,
    });
  }
  return remaining;
}

export async function persistUserSettingsProfile(
  settings: Record<string, unknown>,
  customerRef: string,
  userRef: string,
): Promise<void> {
  const inst = new ViamapPersistenceLayer(
    SettingsManager.getSystemSetting("viamapStoreS3Bucket"),
  );
  const objectRef = inst.createJSONObjectRef(
    PersistenceObjectType.Settings,
    "Mapit",
  );
  await inst.uploadObject(
    PersistenceScope.User,
    PersistenceObjectType.Settings,
    customerRef,
    userRef,
    JSON.stringify(settings),
    objectRef,
    {
      filename: encodeURIComponent(objectRef),
      lastModified: new Date().getTime().toString(),
    },
  );
}
